import { render } from "./EyerwebFooter.vue?vue&type=template&id=71807cc2&scoped=true"
import script from "./EyerwebFooter.vue?vue&type=script&lang=js"
export * from "./EyerwebFooter.vue?vue&type=script&lang=js"

import "./EyerwebFooter.vue?vue&type=style&index=0&id=71807cc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71807cc2"]])

export default __exports__